var d={fontSize:"L",paddingX:"S",paddingY:"S",borderRadius:"NONE"};export{d as default};
